import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import App from './App.vue'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true
  }
})

if (module.hot) {
  module.hot.accept() // already had this init code
  module.hot.addStatusHandler(status => {
    if (status === 'prepare') console.clear()
  })
}

new Vue({
  render: h => h(App),
  created() {
    // console.log(
    //   '%c Modern English 🎂👓',
    //   'color: white; background: black; padding: 4px 4px;'
    // )
    // console.log(
    //   '%c Modern English 🚀',
    //   'color: white; background: black; padding: 4px 4px;'
    // )
    console.log(
      '%c Modern English 💛🧱🛣️',
      'color: white; background: black; padding: 4px 4px;'
    )
    // console.log(
    //   '%c Modern English 🧱',
    //   'color: black; background: gold; padding: 4px 4px;'
    // )
  },
}).$mount('#app')
